import { UseCaseInteractor } from '../../../kernel/use-case'
import { SubModule } from '../domain/module'
import { ModuleRepository } from '../domain/module.repository'

export const getModulePermissionsUseCase: UseCaseInteractor<
  [moduleRepository: ModuleRepository],
  [moduleId: string],
  SubModule[]
> =
  (moduleRepository: ModuleRepository) =>
  async (moduleId): Promise<SubModule[]> => {
    return moduleRepository.getModulePermissions(moduleId)
  }
